import React from 'react';
import Navbar from './zera/Navbar';
import HeroSection from './zera/HeroSection';
import IntroVideo from './zera/IntroVideo';
import DestinationsGrid from './zera/DestinationsGrid';
import ExperiencesSection from './zera/ExperiencesSection';
import DestinationMap from './zera/DestinationMap';
import PlanJourneyForm from './zera/PlanJourneyForm';
import AboutSection from './zera/AboutSection';
import Footer from './zera/Footer';

const AppLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F3]">
      <Navbar />
      <HeroSection />
      <IntroVideo />
      <DestinationsGrid />
      <ExperiencesSection />
      <DestinationMap />
      <PlanJourneyForm />
      <AboutSection />
      <Footer />
    </div>
  );
};

export default AppLayout;
